import { useCallback } from 'react';
import { useFormatter } from 'js/hooks/useFormatter';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

export const useGetExportTransactions = () => {
    const formatter = useFormatter();
    const translate = useComponentTranslations();

    return useCallback(gameTransactions => gameTransactions.map(transaction => {
        const { bet, win, code, datetime, gameName, playerEndBalance, playerStartBalance } = transaction;

        return {
            [translate('column.title.dateTime')]: formatter.getDateTimeShort(formatter.parseImsDate(datetime)),
            [translate('column.title.gameName')]: gameName,
            [translate('column.title.bet')]: formatter.formatCurrency(bet),
            [translate('column.title.win')]: formatter.formatCurrency(win),
            [translate('column.title.startBalance')]: formatter.formatCurrency(playerStartBalance),
            [translate('column.title.endBalance')]: formatter.formatCurrency(playerEndBalance),
            [translate('column.title.code')]: code
        };
    }), [translate, formatter]);
};
